<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'Home' }">Accueil</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Connecteur TITAN
        </li>
      </ol>
    </nav>
    <connector-infos
      :cnt-id="cntId"
      :establishments="establishments"
    />
    <b-row>
      <b-col>
        <b-form-group
          :label="$t('label.select_exist_esta')"
          label-cols-sm="4"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
        >
          <b-input-group size="sm">
            <b-form-input
              list="list_esta"
              id="filterInput"
              v-model="filter"
              type="search"
              @change="filterChange"
              :placeholder="$t('placeholder.find_esta')"
            />
            <b-form-datalist
              id="list_esta"
              :options="filtered"
              value-field="value"
              text-field="text"
              selectable
            >
            </b-form-datalist>
            <b-input-group-append>
              <b-input-group-text>
                <strong>{{ selectedEstablishment?.value }}</strong>
              </b-input-group-text>
              <b-button :disabled="!selectedEstablishment" @click="filter = ''; selectedEstablishment = null; "
                >{{$t('btn.erase')}}</b-button
              >

            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <div>{{ LabelEstaSelected  }}</div>
      </b-col>
    </b-row>
    <hr />
    <b-row v-if="HasSelected">
      <b-col>
        <b-form-group
          :label="$t('connector.label.apikey')"
          label-size="sm"
          label-cols-sm="3"
          label-align-sm="left"
          label-for="ApiKey"
        >
          <b-input-group size="sm">
            <b-form-input
              id="apikey"
              :state="goodApiKey"
              v-model="config.apikey"
              :placeholder="$t('placeholder.connector_key')"
              @change="checkKeyUrl"
            ></b-form-input>
            <b-form-invalid-feedback :state="goodApiKey">
                Clé API transmise par Titan obligatoire.
            </b-form-invalid-feedback>            
          </b-input-group>
        </b-form-group>
        <b-form-group
          :label="$t('placeholder.connector_login')"
          label-size="sm"
          label-cols-sm="3"
          label-align-sm="left"
          label-for="ApiKey"
        >
          <b-input-group size="sm">
            <b-form-input
              id="apilogin"
              :state="goodLoginKey"
              v-model="config.apilogin"
              :placeholder="$t('placeholder.connector_login')"
              @change="checkKeyUrl"
            ></b-form-input>
            <b-form-invalid-feedback :state="goodLoginKey">
                Login transmise par Titan obligatoire.
            </b-form-invalid-feedback>            
          </b-input-group>
        </b-form-group>
        <b-form-group
          :label="$t('placeholder.connector_password')"
          label-size="sm"
          label-cols-sm="3"
          label-align-sm="left"
          label-for="ApiKey"
        >
          <b-input-group size="sm">
            <b-form-input
              id="apipassword"
              :state="goodPasswordKey"
              v-model="config.apipassword"
              :placeholder="$t('placeholder.connector_password')"
              @change="checkKeyUrl"
            ></b-form-input>
            <b-form-invalid-feedback :state="goodPasswordKey">
                Mot de passe transmise par Titan obligatoire.
            </b-form-invalid-feedback>            
          </b-input-group>
        </b-form-group>
        <b-form-group
          :label="$t('connector.label.site_client')"
          label-size="sm"
          label-cols-sm="3"
          label-align-sm="left"
          label-for="Url"
        >
          <b-input-group size="sm">
            <b-form-input
              id="Url"
              v-model="config.apiurl"
              :state="goodUrl"
              @change="checkKeyUrl"
              :placeholder="$t('placeholder.connector_url')"
            ></b-form-input>
           <b-form-invalid-feedback :state="!!config.apiurl">
                Racine du site client pour l'API obligatoire ET doit se terminé par un '/'.
            </b-form-invalid-feedback>            
          </b-input-group>
        </b-form-group>
        <b-form-group
          :label="$t('connector.label.ext_id')"
          label-size="sm"
          label-cols-sm="3"
          label-align-sm="left"
          label-for="Url"
        >
          <b-input-group size="sm">
            <b-form-input
              id="ext_uri"
              type="number"
              v-model="config.ext_uri"
              :state="goodID"
              @change="checkKeyUrl"
              :placeholder="$t('placeholder.connector_ext_id')"
            ></b-form-input>
           <b-form-invalid-feedback :state="!!config.ext_uri">
                ID de l'établissement envoyé par Titan.
            </b-form-invalid-feedback>            

          </b-input-group>
        </b-form-group>

        <b-button
          :disabled="!ApiKeyValid"
          @click="onTestApiKey"
          :variant="ApiKeyValid ? 'outline-secondary': 'warning'"
          >{{ $t("connector.btn.test_api") }}</b-button
        >
      </b-col>
    </b-row>
    <b-row v-if="HasSelected && HasConnectorTitanSelected">
      <b-col>
        <b-card
          border-variant="secondary"
          :header="$t('connector.label.consistency')"
          header-border-variant="secondary"
          align="center"
        >
          <b-card-text>
            <connector-consistency
              :esta="selectedEstablishment?.value"
              :cnt="cntId"
              :config="config"
              connector="TITAN"
            />
          </b-card-text>
        </b-card>
        <b-tabs pills card vertical v-model="connectorSelected">
          <b-tab
            title="admin"
            v-b-tooltip
          >
            <template #title>
              <font-awesome-icon
                :icon="['fas', 'sync-alt']"
              />
            </template>
            <template>
              <b-container>
                <b-row class="w-100 border-top border-bottom border-dark align-items-center">
                  <b-col sm="8" class="text-info mb-3 font-italic">
                    Activer le connecteur pour l'établissement
                  </b-col>
                  <b-col sm="2">
                    <b-form-group
                      size="sm"
                      :label="$t('connector.label.enable')"
                      label-size="sm"
                      label-cols-sm="1"
                      label-align-sm="left"
                      label-for="Actif"
                    >
                      <b-form-checkbox
                        id="Actif"
                        v-model="config.enable"
                        :disabled="!ApiKeyValid"
                        switch
                        size="md"
                        variant="success"
                      >
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                  <b-col sm="1" >
                    <b-button
                      variant="success"
                      :disabled="!saveEnabled || !haveActivitiesConf || !goodForm"
                      @click="SaveTITAN()"
                    >{{$t('btn.save')}}</b-button>
                  </b-col>                  
                </b-row>
                <b-row>
                  <b-col>
                    <h6>Paramètres nécessaires </h6>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <p>Afin de pouvoir configurer le connecteur pour l'établissement, veuillez vérifier que les activités ci-dessous soient bien mappé avec ceux de Titan:</p>
                    <b-table
                      small
                      responsive="sm"
                      :fields="fieldsRefs"
                      :items="[getAnisenActivityConf, getRefusConf, getLieuRefConf]"
                      >
                      <template #cell(exturi)="row">
                        <b-col>
                          <b-form-select v-if="row.item.name === 'Refus'" v-model="row.item.exturi" :options="notations"></b-form-select>
                          <b-form-select v-else-if="row.item?.name === 'LieuRef'" v-model="row.item.exturi" :options="places"></b-form-select>
                          <b-form-input disabled v-else v-model="row.item.exturi" />
                          <div v-if="row.item.exturi === null && row.item.name !== 'Activity'" class="text-danger">Veuillez spécifier cette valeur</div>
                          <div v-if="row.item.exturi === null && row.item.name === 'Activity'" class="text-danger">Impossible de créer/trouver une activité ANISEN, veuillez contacter le BED.</div>
                        </b-col>
                      </template>
                    </b-table>
                  </b-col>
                </b-row>
              </b-container>
              <b-tabs
                content-class="mt-3"
                pills
                card
                justified
                active-nav-item-class="font-weight-bold text-uppercase text-white bg-dark"
              >
                <b-tab
                  :title="$t('connector.label.parameters')"
                  active
                  :disabled="!HasConnectorTitanSelected"
                  title-link-class="text-white bg-secondary"
                >

                  <b-row>
                    <b-col>
                      <b-form-group
                        :label="$t('connector.label.push_activities')"
                        label-size="sm"
                        label-cols-sm="6"
                        label-align-sm="left"
                      >
                        <b-row>
                          <b-col>
                            <b-form-checkbox
                              v-model="config.enable_push_activity"
                              switch
                              size="md"
                              variant="success"
                              @change="!$event ? config.enable_push_patgames = false : null"
                            >
                              {{ $t("connector.label.enable") }}
                            </b-form-checkbox>
                          </b-col>
                          <b-col>
                            <b-form-checkbox
                              v-model="config.enable_push_patgames"
                              switch
                              size="md"
                              variant="success"
                              @change="$event ? config.enable_push_activity = true : null"
                            >
                              {{ $t("connector.label.enable_patgames") }}
                            </b-form-checkbox>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-container class="full-container">
                        <b-card-group deck>
                          <b-card
                            border-variant="secondary"
                            :header="$t('connector.label.list_job')"
                            header-border-variant="secondary"
                            align="center"
                          >
                            <b-card-text
                              ><list-jobs
                                :mappedMetiers="config.metiers"
                                :sourceMetiers="metiers"
                                :config="config"
                                connector="TITAN"
                                @update-metier="updateMetier"
                              />
                            </b-card-text>
                          </b-card>
                        </b-card-group>
                      </b-container>
                      <b-container class="full-container">
                        <b-card-group deck>
                          <b-card
                            border-variant="secondary"
                            :header="$t('connector.label.list_filter_job')"
                            header-border-variant="secondary"
                            align="center"
                          >
                            <b-card-text
                              ><filter-jobs :jobs="filterJobs" @update-filter-job="updateFilterJob" />
                            </b-card-text>
                          </b-card>
                        </b-card-group>
                      </b-container>
                    </b-col>
                  </b-row>
                </b-tab>
                <b-tab
                  :title="$t('connector.label.mapping')"
                  :disabled="!HasConnectorTitanSelected"
                  title-link-class="text-white bg-secondary"
                >
                  <b-row>
                    <b-col>
                      <b-container class="full-container">
                        <b-card-group deck>
                          <b-card
                            border-variant="secondary"
                            :header="$t('connector.label.list_service')"
                            header-border-variant="secondary"
                            align="center"
                          >
                            <b-card-text
                              ><list-services
                                :type="config.service.source"
                                :keyapi="config.apikey"
                                :urlapi="config.apiurl"
                                :esta="selectedEstablishment?.value"
                                :cnt="TITANConnector?.id"
                                :config="config"
                                connector="TITAN"
                                :ctx="config.ctx"
                              />
                            </b-card-text>
                          </b-card>
                        </b-card-group>
                      </b-container>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-container class="full-container">
                        <b-card-group deck>
                          <b-card
                            border-variant="secondary"
                            :header="$t('connector.label.list_place')"
                            header-border-variant="secondary"
                            align="center"
                          >
                            <b-card-text
                              ><list-lieux
                                :config="config"
                                connector="TITAN"
                                :esta="selectedEstablishment?.value"
                                :cnt="TITANConnector?.id"
                                :ctx="config.ctx"
                              />
                            </b-card-text>
                          </b-card>
                        </b-card-group>
                      </b-container>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-container class="full-container">
                        <b-card-group deck>
                          <b-card
                            border-variant="secondary"
                            :header="$t('connector.label.list_resident')"
                            header-border-variant="secondary"
                            align="center"
                          >
                            <b-card-text
                              ><list-residents
                                :esta="selectedEstablishment?.value"
                                :cnt="TITANConnector?.id"
                                :config="config"
                                connector="TITAN"
                                :ctx="config.ctx"
                              />
                            </b-card-text>
                          </b-card>
                        </b-card-group>
                      </b-container>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-container class="full-container">
                        <b-card-group deck>
                          <b-card
                            border-variant="secondary"
                            :header="$t('connector.label.list_personnel')"
                            header-border-variant="secondary"
                            align="center"
                          >
                            <b-card-text
                              ><list-personnels
                                :esta="selectedEstablishment?.value"
                                :cnt="TITANConnector?.id"
                                :config="config"
                                connector="TITAN"
                                :ctx="config.ctx"
                              />
                            </b-card-text>
                          </b-card>
                        </b-card-group>
                      </b-container>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </template>
          </b-tab>
          <b-tab
            title="push"
            v-b-tooltip
          >
            <template #title>
              <font-awesome-icon :icon="['fas', 'sign-in-alt']" />
            </template>
            <template>
              <b-container>
                <b-row class="w-100 border-top border-bottom border-dark align-items-center"
                  ><b-col sm="8" class="text-info mb-3 font-italic">
                    Activer le connecteur pour l'établissement
                  </b-col>
                  <b-col sm="2">
                    <b-form-group
                      size="sm"
                      :label="$t('connector.label.enable')"
                      label-size="sm"
                      label-cols-sm="1"
                      label-align-sm="left"
                      label-for="pActif"
                    >
                      <b-form-checkbox
                        id="pActif"
                        v-model="config.enable"
                        :disabled="!ApiKeyValid"
                        switch
                        size="md"
                        variant="success"
                      >
                      </b-form-checkbox>
                      
                    </b-form-group>
                  </b-col>
                  <b-col sm="1" >
                    <b-button
                      variant="success"
                      :disabled="!saveEnabled || !haveActivitiesConf || !goodForm"
                      @click="SaveTITAN()"
                    >{{$t('btn.save')}}</b-button>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <h6>Paramètres nécessaires </h6>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <p>Afin de pouvoir configurer le connecteur pour l'établissement, veuillez vérifier que les activités ci-dessous soient bien liées avec ceux de Titan :</p>
                    <b-table
                      small
                      responsive="sm"
                      :fields="fieldsRefs"
                      :items="[getAnisenActivityConf, getRefusConf, getLieuRefConf]"
                      >
                      <template #cell(exturi)="row">
                        <b-col>
                          <b-form-select v-if="row.item.name === 'Refus'" v-model="row.item.exturi" :options="notations"></b-form-select>
                          <b-form-select v-else-if="row.item?.name === 'LieuRef'" v-model="row.item.exturi" :options="places"></b-form-select>
                          <b-form-input disabled v-else v-model="row.item.exturi" />
                          <div v-if="row.item.exturi === null && row.item.name !== 'Activity'" class="text-danger">Veuillez spécifier cette valeur</div>
                          <div v-if="row.item.exturi === null && row.item.name === 'Activity'" class="text-danger">Impossible de créer/trouver une activité ANISEN, veuillez contacter le BED.</div>
                        </b-col>
                      </template>
                    </b-table>
                  </b-col>
                </b-row>
              </b-container>
              <b-container>
                <b-row class="mt-3">
                  <b-col sm="5">
                    <i>{{$t('connector.label.transmission')}}</i>
                  </b-col>
                  <b-col sm="2" />
                  <b-col sm="5">
                    <i>{{$t('connector.label.report')}}</i>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col sm="5" class="border-top">
                    <b-form-group
                      :label="$t('connector.label.enable')"
                      label-size="sm"
                      label-cols-sm="4"
                      label-align-sm="left"
                      label-for="tenable"
                    >
                      <b-form-checkbox
                        id="tenable"
                        v-model="config.push.trans.enable"
                        switch
                        size="md"
                        variant="success"
                      >
                      </b-form-checkbox>
                    </b-form-group>              
                  </b-col>
                  <b-col sm="2" />
                  <b-col sm="5" class="border-top">
                    <b-form-group
                      :label="$t('connector.label.enable')"
                      label-size="sm"
                      label-cols-sm="4"
                      label-align-sm="left"
                      label-for="renable"
                    >
                      <b-form-checkbox
                        id="renable"
                        v-model="config.push.report.enable"
                        switch
                        size="md"
                        variant="success"
                      >
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-container>
            </template>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <modal-connector-error
      ref="modalError"
      :error-summary="$t('connector.error.titan_summary')"
      :errors="detailedErrors"
    />
  </div>
</template>

<script>
import {
  getAllEstablishment,
  getEstablishmentById,
  getServiceForEstablishments,
  SetConnectorData,
  GetConnectorData,
} from "../services/establishment";
import ListJobs from "../components/lists/ListMappingJobs.vue";
import FilterJobs from "../components/lists/ListFilterJobs.vue";
import ListResidents from "../components/lists/ListMappingResidents.vue";
import ListPersonnels from "../components/lists/ListMappingPersonnels.vue";
import ListServices from "../components/lists/ListMappingServices.vue";
import ListLieux from "../components/lists/ListMappingLieux.vue";
import ConnectorInfos from "../components/ConnectorInfos.vue";
import ConnectorConsistency from "../components/ConnectorConsistency.vue";
import ModalConnectorError from "../components/ModalConnectorError.vue";
import { Connectors, JobsList } from "../services/global";
import ApiTitan from "../services/titan";
import { checkUrl } from "../misc/urlnetsoins"

export default {
  components: {
    ListJobs,
    ListResidents,
    ListPersonnels,
    ListServices,
    ListLieux,
    FilterJobs,
    ConnectorInfos,
    ConnectorConsistency,
    ModalConnectorError,
  },
  name: "Connector",
  data() {
    return {
      api: null,
      metiers: null,
      estaDetails: null,
      jobs: null,
      filterJobs: null,
      selectedEstablishment: null,
      establishments: null,
      ApiKeyValid: false,
      filtered: null,
      filter: null,
      connectors: null,
      connectorSelected: null,
      services: ["DEPT"], //, "SECTEUR", "SOUSSECTEUR"],
      estaServices: null,
      participants: null,
      config: {
        ctx: null,
        enable: false,
        enablepush: false,
        apikey: null,
        login: null,
        password: null,
        apiurl: null,
        metiers: null,
        enable_push_activity: false,
        enable_push_patgames: false,
        service: {
          source: "DEPT",
          default: null,
        },
        jobsfilter: {},
        push: {
          trans: { html: true, enable: false, template: 'anisen.html'},
          report: {html: true, enable: false, template: 'anisenreport.html',
            references: []
          }
        }
       
      },
      fieldsRefs: [
        {
          name: {
            label: "Type",
            sortable: true,
            tdClass: "align-middle text-left",
          },
        },
        {
          exturi: {
            label: "id partenaire",
            sortable: true,
            tdClass: "align-middle",
          },
        },      
      ],
      saveEnabled: false,
      notations: [],
      places: [],
      error: null,
    };
  },
  async created() {
    this.jobs = await JobsList();
    this.establishments = await getAllEstablishment(null, true);
    this.filtered = this.establishments.map((e) => {
      {
        return e.text;
      }
    });
    const cons = await Connectors("TITAN");
    if (cons) {
      this.connectors = cons;
    } else {
      this.connectors = [
        { id: 5, name: "TITAN", model: null, enable: true },
      ];
    }
    this.connectorSelected = 0;
    this.api = new ApiTitan(this.config.urlapi, this.config.apilogin, this.config.apipassword, this.config.apikey);
  },
  methods: {
    updateMetier(item){
      const mapped = this.config.metiers.find(m=>m.ext_id === item.Uri);
      if (mapped) {
        mapped.id = item.id;
      } else {
        this.config.metiers.push({
          ext_id: item.Uri,
          ext_name: item.Libelle,
          id: item.id
        })
      }
    },
    updateFilterJob(item){
      const i = this.config.jobsfilter.indexOf( item.Id)
      if (!item.Include && i !== -1) this.config.jobsfilter.splice(i, 1)
      if (item.Include && i === -1) this.config.jobsfilter.push(item.Id)
    },
    async SaveTITAN() {
      if (!this.haveActivitiesConf) {
        return
      }
      const result = await SetConnectorData(this.selectedEstablishment.value, this.TITANConnector, this.config);
      this.config.saved = result.good;
      if (this.config.saved && !this.config.ctx) this.config.ctx = result.eec_id;
    },  
    async onConnectorSelected(items) {
      this.connectorSelected = items[0];
    },
    async filterChange() {
      this.saveEnabled = false;
      
      this.selectedEstablishment = this.establishments.find(
        (e) => this.filter === e.text
      );
      if (this.selectedEstablishment) {
        this.estaDetails = await getEstablishmentById(this.selectedEstablishment.value);
        this.estaServices = await getServiceForEstablishments(
          this.selectedEstablishment.value,
          true
        );
        if (this.estaServices) {
          this.config.service.default = this.estaServices.find(
            (s) => s.default === true
          )?.value;
        }
        this.getConnectorsForEsta();
        this.saveEnabled = true;
      } 
      else {      
        this.defaultConfig();
      }

    },
    async onTestApiKey() {
      this.error = null;
      this.api = new ApiTitan(this.config.apilogin, this.config.apipassword, this.config.apikey, this.config.apiurl, this.config.ext_uri);

      try {
        const anisenActivity = await this.api.createOrGetAnisenActivity();
        this.saveEnabled = anisenActivity !== null;
        if (this.getAnisenActivityConf) {
          this.getAnisenActivityConf.exturi = 'TITAN://activity#' + anisenActivity.id;
        }
        this.notations = (await this.api.getNotations()).map(n => { return { value: 'TITAN://notation#' + n.id, text: n.name } });
        this.places = (await this.api.getPlaces()).map(n => { return { value: 'TITAN://place#' + n.id, text: n.name } });
        this.ApiKeyValid = anisenActivity !== null;
        ///////////////
        this.metiers = await this.api.getJobs();
      } catch (error) {
        this.ApiKeyValid = false;
        this.saveEnabled = false;

        this.error = error;
        this.$refs.modalError.show();
      }
    },
    checkKeyUrl() {
      if (this.config?.apikey?.length > 0 
        && this.config?.apiurl?.length > 0
        && this.config?.apilogin?.length > 0
        && this.config?.apipassword?.length > 0)
        {
          this.onTestApiKey();
        }
      else {
        this.ApiKeyValid = false;
      }
    },
    async getConnectorsForEsta() {
      this.defaultConfig();

      const conf = await GetConnectorData(
        this.selectedEstablishment.value,
        this.connectors 
        );
      if (conf) {
        this.config = conf;
      }
      this.filterJobs = this.jobs
        .map((j) => {
          return {
            Id: j.value,
            Name: j.text,
            Include: !(conf.jobsfilter)? false: conf.jobsfilter?.find((f) => f === j.value) != null,
          };
        })
        .sort((a, b) => a.Id - b.Id);

      this.checkKeyUrl();
    },
    defaultConfig(){
      this.metiers = null
      this.config = {
          ctx: null,
          enable: false,
          apikey: null,
          apiurl: null,
          metiers: null,
          login: 'anisen',
          enable_push_activity: false,
          enable_push_patgames: false,
          service: {
            source: "DEPT",
            default: null,
          },
          jobsfilter: {},
          push: {
            trans: { html: true, enable: false, template: 'anisen.html'},
            report: {html: true, enable: false, template: 'anisenreport.html',
              references: [
                {
                  "name": "Activity",
                  "exturi": null, //"TITAN://activity#ID",
                  "default": "Anisen"
                },
                {
                  "name": "Refus",
                  "exturi": null, //"TITAN://notation#null",
                  "default": ""
                },
                {
                  "name": "LieuRef",
                  "exturi": null, //"TITAN://place#ID",
                  "default": ""
                }
              ]
            }
          } 
      }
    }
  },
  computed: {
    cntId() {
      return this.connectors?.find(cnt => cnt.name === "TITAN")?.id;
    },
    haveActivitiesConf() {
      return (this.getAnisenActivityConf?.exturi ??null) !== null &&
        (this.getRefusConf?.exturi ??null) !== null &&
        (this.getLieuRefConf?.exturi ??null) !== null
    },
    getAnisenActivityConf() {
      return this.config.push.report.references.find(r => r.name === 'Activity') ?? null
    },
    getRefusConf() {
      return this.config.push.report.references.find(r => r.name === 'Refus') ?? null
    },
    getLieuRefConf() {
      return this.config.push.report.references.find(r => r.name === 'LieuRef') ?? null
    },
    LabelEstaSelected(){
      return `${(this.selectedEstablishment)? this.selectedEstablishment.text : ''} - ${ (this.estaDetails) ? this.estaDetails.esta_postalcode: ''} ${(this.estaDetails)? this.estaDetails.esta_city: ''} ${(this.estaDetails && this.estaDetails.parent?.esta_id > 0)? '(' + this.estaDetails.parent.esta_name + ')' : ''}`;
    },
    HasSelected() {
      return this.selectedEstablishment?.value > 0;
    },
    HasConnectorSelected() {
      return this.connectorSelected?.id > 0;
    },
    HasConnectorTitanSelected() {
      return this.ApiKeyValid;
    },
    TITANConnector() {
      return this.connectors?.[0];
    },
    goodUrl(){
      return checkUrl(this.config.apiurl) && this.config.apiurl.slice(-1) === '/'
    },
    goodID() {
      return !isNaN(this.config.ext_uri) && this.config.ext_uri > 0
    },
    goodApiKey(){
      return this.config?.apikey?.length > 0;
    },
    goodLoginKey() {
      return this.config?.apilogin?.length > 0;
    },
    goodPasswordKey() {
      return this.config?.apipassword?.length > 0;
    },
    goodForm() {
      return this.goodUrl && this.goodID && this.goodApiKey && this.goodPasswordKey && this.goodLoginKey;
    },
    detailedErrors() {
      return [
        {
          title: this.$t("connector.error.proxy_title", ["TITAN"]),
          error: this.error,
        },
      ];
    },
  },
};
</script>

<style scoped >
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff !important;
  border-color: #138022 !important;
  background-color: #138022 !important;
}
</style>
